const MULTIPLIER = 4;
const spacing = {
  "spacing-0": { value: `${MULTIPLIER * 0}px` },
  "spacing-05": { value: `${MULTIPLIER * 0.5}px` },
  "spacing-1": { value: `${MULTIPLIER * 1}px` },
  "spacing-2": { value: `${MULTIPLIER * 2}px` },
  "spacing-3": { value: `${MULTIPLIER * 3}px` },
  "spacing-4": { value: `${MULTIPLIER * 4}px` },
  "spacing-5": { value: `${MULTIPLIER * 5}px` },
  "spacing-6": { value: `${MULTIPLIER * 6}px` },
  "spacing-7": { value: `${MULTIPLIER * 7}px` },
  "spacing-8": { value: `${MULTIPLIER * 8}px` },
  "spacing-12": { value: `${MULTIPLIER * 12}px` },
  "spacing-16": { value: `${MULTIPLIER * 16}px` },
  "spacing-20": { value: `${MULTIPLIER * 20}px` },
  "spacing-24": { value: `${MULTIPLIER * 24}px` },
  "spacing-28": { value: `${MULTIPLIER * 28}px` },
  "spacing-32": { value: `${MULTIPLIER * 32}px` }
};
export {
  spacing
};
//# sourceMappingURL=spacing.es.js.map
